import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import './style/style.scss';
import Heliodon from './heliodon';
import reportWebVitals from './reportWebVitals';
import { parentContext } from './context';

const HelioParent = () => {
  const [parent, setParent] = useState(null);

  return (
    <parentContext.Provider value={{ parent, setParent }}>
      <Heliodon />
    </parentContext.Provider>
  )
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelioParent />
  </React.StrictMode>,
);

reportWebVitals();